<template>
    <div class="video">
      <div class="video__block" data-aos="zoom-out" data-aos-delay="300" ref="videoBlock">
        <!-- <div 
          class="video__icon"
          :class="{ 'is-playing': isPlaying }"
          @click="handleVideoClick"
        ></div> -->
        <video
          ref="videoPlayer"
          class="video__bg"
          loop="loop"
          muted="true"
          playsinline="true"
          preload="none"
          :poster="poster"
          @play="handleVideoPlay"
          @pause="handleVideoPause"
        >
          <source :src="videoSrc" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <!-- <div class="video__overlay" @click="handleVideoClick">
          <div :class="{ 'is-playing': isPlaying }"></div>
        </div> -->
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue'
  
  const props = defineProps({
    videoSrc: {
      type: String,
      required: true
    },
    poster: {
      type: String,
      default: '/static/images/home/bg/video-cover.jpg'
    }
  })
  
  const videoPlayer = ref(null)
  // const isPlaying = ref(false)
  const videoBlock = ref(null)
  let observer = null
  
  // const handleVideoPlay = () => {
  //   isPlaying.value = true
  // }
  
  // const handleVideoPause = () => {
  //   isPlaying.value = false
  // }
  
  // const handleVideoClick = () => {
  //   if (videoPlayer.value.paused) {
  //     videoPlayer.value.play()
  //   } else {
  //     videoPlayer.value.pause()
  //   }
  // }
  
  onMounted(() => {
    observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          videoPlayer.value.play()
        } else {
          videoPlayer.value.pause()
        }
      })
    }, {
      threshold: 0.5
    })

    if (videoBlock.value) {
      observer.observe(videoBlock.value)
    }
  })

  onUnmounted(() => {
    if (observer) {
      observer.disconnect()
    }
  })
  </script>
  
  <style lang="scss" scoped>
  @import "@/assets/scss/app";
  
  .video {
    cursor: pointer;

    .video__block {
      position: relative;
      width: 100%;
      text-align: center;
    }
  
    .video__icon {
      position: absolute;
      top: 50%;  
      left: 50%;
      transform: translate(-50%, -50%); 
      z-index: 1;
      width: 138px;
      height: 138px;
      background-image: url('/static/images/default/icons/play.svg');
      background-repeat: no-repeat;
      background-position: center;
      background-size: 138px;
      opacity: 1;
      transition: opacity 0.3s ease;
      pointer-events: auto;
  
      &.is-playing {
        opacity: 0;
        pointer-events: none;  
      }
  
      @include media-breakpoint-down(md) {
        background-size: 64px;
      }
    }
  
    .video__bg {
      position: relative;
      object-fit: cover;
      height: auto;
      max-width: 100%;
      max-height: 590px;
  
      &::-webkit-media-controls {
        opacity: 0;
        transition: opacity 0.3s;
      }
      
      &:hover {
        &::-webkit-media-controls {
          opacity: 1;
        }
      }
    }

    .video__overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0; 
      cursor: pointer;
      pointer-events: none;
    }
}
  

  </style>